var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.value && _vm.value.length)?_c('div',[_c('v-card-text',{staticClass:"pt-1 pb-2"},[_c('span',{staticClass:"text-h5 text--darken-1 "},[_vm._v(" Course types: ")]),_vm._v(" "+_vm._s(_vm.value)+" ")])],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }